/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelcityplaceholder2Inputs */

const en_channelcityplaceholder2 = /** @type {(inputs: Channelcityplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Linz`)
};

const de_channelcityplaceholder2 = /** @type {(inputs: Channelcityplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Linz`)
};

/**
* | output |
* | --- |
* | "e.g. Linz" |
*
* @param {Channelcityplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelcityplaceholder2 = /** @type {((inputs?: Channelcityplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelcityplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelcityplaceholder2(inputs)
	return de_channelcityplaceholder2(inputs)
});
export { channelcityplaceholder2 as "channelCityPlaceholder" }